import style from '../css/Report.module.css';
import { useState, useEffect } from 'react';

const fontSizeMapping = {
  "크게": 14,
  "보통": 12,
  "작게": 10,
  "최소": 8
};

const lineHeightMapping = {
  "넓게": 300,
  "보통": 160,
  "좁게": 140,
  "최소": 110
};

function Side({ handleGeneratePDF, pdfUrl, jsonData }) {

  // 시험지(Test Paper) vs. 답안지(Answer Sheet) 
  // Answer Sheet: 학생이 답을 작성하는 용지    answerSheetLanguage 
  // Exam Answers: 시험의 정답을 의미하는 경우  examPaperLanguage 

  const [selectedOptions, setSelectedOptions] = useState({
    printType: '',  // 'LIST'
    materialType: '', // 'WORD'
    // targetType: '',
    userRole: '',
    answerSheetLanguage: 'KOREAN',
    shuffle1: 'original',
    shuffle2: 'view',
    wordStep: 'step1',
    sentenceStep: 'step1',

    isSolution: true,       // 정답지 추가 ==> 시험지 옵션, "해설지 추가" 옵션 따로 있음

    testType: 'EXAM',  // 'EXAM' : 시험(전체), 'STEP' : 구간테스트 // 자가채점 에서 사용함 
    testRange: 'EXAM', // 'EXAM' : 시험(전체), 'STEP' : 구간테스트 // 시험지 에서 사용함

    printRange: 'FULL', // FULL (전체 인쇄), PARTOFERROR (오답인쇄) // 자가채점 에서 사용함

    isHeader: false,   // 헤더표시 체크박스
    isKorean: false, // 'Eng' // 답지구분
    shuffle: 'original',    // original, ramdom, abc, 문장(abc 없음 )
    // shuffle: 'abc', // 문장일 때는 안됨
    isQuestionNumber: true, // 번호표시, true / false, 
    isPrintDate: true,    // 출력시간,

    // 자가채점
    isAnswerRange: true, // 인쇄범위 : 전체 (true), 오답 (false)
    isExplanation: true, // 해설추가 : 추가, 제외

    // 시험지
    // 시험지-문장
    // emptyQCnt: 0,			// 빈칸채우기 - 문항수, (빈칸수-sub옵션 필수 지정 필요)
    // emptyQBlankCnt: 0,	// 빈칸채우기 - 빈칸수, (sub옵션 필수 지정 필요)
    isFirstWord: true,	// 빈칸채우기 - 빈칸첫단어제외 : 체크 (true / false)
    studentName: '',    // 학생 이름 
    isStudentName: true,  // 이름 표시하기 

    isDivBreak: true,   // 화면출력할때, 문단이 중간에 끊어지지 않게 한다. (true) 블럭이 유지된다. / (false) 블럭이 깨진다. 

    // WORD, SENTENCE, TEST 공통 문제 설정
    qCnt: 0,
    isShuffle: false, // 체크박스
    studysetName: '',

    // WORD용 문제 설정
    wordQ1Cnt: 0,
    wordQ2Cnt: 0,
    meaningQ1Cnt: 0,
    meaningQ2Cnt: 0,
    exampleQ1Cnt: 0,
    exampleQ2Cnt: 0,

    // SENTENCE용 문제 설정
    emptyQCnt: 0,
    emptyQBlankCnt: 0,
    orderQCnt: 0,
    meaningQCnt: 0,
    inputQCnt: 0,

    // TEST용 문제 설정
    textQCnt: 0,
    grammarQCnt: 0,
    listenQCnt: 0,
  });

  const [dialogVisible, setDialogVisible] = useState(false); // Dialog 표시 여부
  const [selectedWordSteps, setSelectedWordSteps] = useState([]); // 선택된 word_step_id 목록
  const [isAllSelected, setIsAllSelected] = useState(true); // 전체 선택 여부

  const [shareDialogVisible, setShareDialogVisible] = useState(false);
  const isReportCardView = (pdfUrl === null); // true면 ReportCard, false면 Content

  // 내부적으로 저장될 상태 (기본값: 보통)
  const [selectedFontSize, setSelectedFontSize] = useState("보통");
  const [selectedLineHeight, setSelectedLineHeight] = useState("보통");

  // 실제 적용될 숫자 값
  const appliedFontSize = fontSizeMapping[selectedFontSize];
  const appliedLineHeight = lineHeightMapping[selectedLineHeight];


  // const openShareDialog = () => setShareDialogVisible(true);
  const openShareDialog = () => {
    setShareDialogVisible(true);
  }
  const closeShareDialog = () => setShareDialogVisible(false);

  // JSON 데이터에서 stepInfo 가져오기
  const wordStepCount = jsonData?.jsonData.stepInfo || [];

  // 각 항목의 총합을 저장하는 상태
  const [totals, setTotals] = useState({ text: 0, grammar: 0, listen: 0 });

  // 선생님 > 시험지 > 단어 > 시험지 출력
  // 총 cntWord 합 저장 상태
  const [totalCntWord, setTotalCntWord] = useState(0);

  // 선생님 > 시험지 > 문장 > 시험지 출력
  // 총 가능 문장 수 저장 (stepInfo에서 cntSentence 합산)
  const [totalCntSentence, setTotalCntSentence] = useState(0);

  // 총 입력된 값 합계 계산 함수
  const getCurrentTotal = () => {
    if (selectedOptions.printType === 'TEST') {
      if (selectedOptions.materialType === 'WORD') {
        return (
          Number(selectedOptions.wordQ1Cnt) +
          Number(selectedOptions.wordQ2Cnt) +
          Number(selectedOptions.meaningQ1Cnt) +
          Number(selectedOptions.meaningQ2Cnt) +
          Number(selectedOptions.exampleQ1Cnt) +
          Number(selectedOptions.exampleQ2Cnt)
        );
      }
      if (selectedOptions.materialType === 'SENTENCE') {
        return (
          Number(selectedOptions.emptyQCnt) +
          Number(selectedOptions.orderQCnt) +
          Number(selectedOptions.meaningQCnt) +
          Number(selectedOptions.inputQCnt)
        );
      }
      if (selectedOptions.materialType === 'TEST') {
        return (
          Number(selectedOptions.textQCnt) +
          Number(selectedOptions.grammarQCnt) +
          Number(selectedOptions.listenQCnt)
        );
      }
    }
    return 0;
  };

  useEffect(() => {
    if (jsonData) {
      const reportType = jsonData.jsonData.reportType || 'LIST';

      // JSON 데이터를 기반으로 상태 업데이트
      setSelectedOptions((prev) => ({
        ...prev,
        printType: reportType === 'WORKBOOK' ? 'LIST' : reportType, // WORKBOOK이면 LIST 기본 설정
        materialType: jsonData.jsonData.studysetType || 'WORD',
        userRole: jsonData.jsonData.userRole || 'ROLE_INST_CHIEF',
        studysetName: jsonData.jsonData.studysetName || '',
        studentName: jsonData.jsonData.studentName || '',
        testType: jsonData.jsonData.testType || '',
      }));

      // const studysetType = jsonData.jsonData.studysetType;  // WORD, SENTENCE, TEST
      if (reportType === 'TEST') {
        // TEST 모드: 첫 번째 항목만 선택
        if (wordStepCount.length > 0) {
          setSelectedWordSteps([wordStepCount[0].stepId]);

          // 1) studysetType === 'WORD' (materialType)
          const total = wordStepCount.reduce((sum, item) => sum + (item.cntWord || 0), 0);
          setTotalCntWord(total);

          // 2) studysetType === 'SENTENCE' (materialType)
          const total2 = wordStepCount.reduce((sum, step) => sum + (step.cntSentence || 0), 0);
          setTotalCntSentence(total2);

          // 3) studysetType === 'TEST' (materialType)
          const totalTextItem = wordStepCount.reduce((sum, item) => sum + (item.cntTextItem || 0), 0);
          const totalGrammarItem = wordStepCount.reduce((sum, item) => sum + (item.cntGrammarItem || 0), 0);
          const totalListenItem = wordStepCount.reduce((sum, item) => sum + (item.cntListenItem || 0), 0);

          setTotals({
            text: totalTextItem,
            grammar: totalGrammarItem,
            listen: totalListenItem,
          });

        } else {
          setSelectedWordSteps([]);
        }
      } else {
        // LIST 또는 WORKSHEET 모드: 모든 항목 선택
        const allIds = wordStepCount.map((step) => step.stepId);
        setSelectedWordSteps(allIds);
        setIsAllSelected(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonData]);

  // `totals` 값 업데이트 함수
  const updateInputs = () => {

    if (selectedOptions.printType === 'TEST') {
      if (wordStepCount.length > 0) {
        // (selectedOptions.testRange === "EXAM") || (selectedOptions.testRange === "STEP")

        // 1) studysetType === 'WORD' (materialType)
        if (selectedOptions.materialType === 'WORD') {
          setSelectedOptions((prev) => ({
            ...prev,
            wordQ1Cnt: 0,
            wordQ2Cnt: 0,
            meaningQ1Cnt: 0,
            meaningQ2Cnt: 0,
            exampleQ1Cnt: 0,
            exampleQ2Cnt: 0,
            qCnt: 0,
          }));
        }
        // 2) studysetType === 'SENTENCE' (materialType)
        if (selectedOptions.materialType === 'SENTENCE') {
          setSelectedOptions((prev) => ({
            ...prev,
            emptyQCnt: 0,
            orderQCnt: 0,
            meaningQCnt: 0,
            inputQCnt: 0,
            qCnt: 0,
          }));
        }
        // 3) studysetType === 'TEST' (materialType)
        if (selectedOptions.materialType === 'TEST') {
          setSelectedOptions((prev) => ({
            ...prev,
            textQCnt: 0,
            grammarQCnt: 0,
            listenQCnt: 0,
            qCnt: 0,
          }));
        }
      }
    }
  };

  // `totals` 값 업데이트 함수
  const updateTotals = () => {

    if (selectedOptions.printType === 'TEST') {
      if (wordStepCount.length > 0) {
        if (selectedOptions.testRange === "EXAM") { // 전체

          // 1) studysetType === 'WORD' (materialType)
          if (selectedOptions.materialType === 'WORD') {
            const total = wordStepCount.reduce((sum, item) => sum + (item.cntWord || 0), 0);
            setTotalCntWord(total);
          }
          // 2) studysetType === 'SENTENCE' (materialType)
          if (selectedOptions.materialType === 'SENTENCE') {
            const total = wordStepCount.reduce((sum, step) => sum + (step.cntSentence || 0), 0);
            setTotalCntSentence(total);
          }
          // 3) studysetType === 'TEST' (materialType)
          if (selectedOptions.materialType === 'TEST') {
            // '전체' 선택 시 모든 stepInfo 데이터 합산
            const totalTextItem = wordStepCount.reduce((sum, item) => sum + (item.cntTextItem || 0), 0);
            const totalGrammarItem = wordStepCount.reduce((sum, item) => sum + (item.cntGrammarItem || 0), 0);
            const totalListenItem = wordStepCount.reduce((sum, item) => sum + (item.cntListenItem || 0), 0);

            setTotals({
              text: totalTextItem,
              grammar: totalGrammarItem,
              listen: totalListenItem,
            });
          }
        } else if (selectedOptions.testRange === "STEP") {  // 일부

          // 1) studysetType === 'WORD' (materialType)
          if (selectedOptions.materialType === 'WORD') {
            const selectedStep = wordStepCount.find((item) => item.stepId === selectedWordSteps[0]);
            setTotalCntWord(selectedStep?.cntWord || 0);
          }
          // 2) studysetType === 'SENTENCE' (materialType)
          if (selectedOptions.materialType === 'SENTENCE') {
            // const total = wordStepCount.reduce((sum, step) => sum + (step.cntSentence || 0), 0);
            const selectedStep = wordStepCount.find((item) => item.stepId === selectedWordSteps[0]);
            setTotalCntSentence(selectedStep?.cntSentence || 0);
          }

          // 3) studysetType === 'TEST' (materialType)
          // '일부' 선택 시 특정 stepId 데이터만 반영
          if (selectedOptions.materialType === 'TEST') {
            const selectedStep = wordStepCount.find((item) => item.stepId === selectedWordSteps[0]);
            setTotals({
              text: selectedStep?.cntTextItem || 0,
              grammar: selectedStep?.cntGrammarItem || 0,
              listen: selectedStep?.cntListenItem || 0,
            });
          }
        }
      }
    }

  };

  // `selectionMode` 변경 시 `totals` 업데이트
  useEffect(() => {
    if (selectedOptions.printType === 'TEST') {
      // ('====> 시험지 > 문제집 > 시험범위 변경 <====')
      updateTotals();
    } else {
      // ('==> (일반) 시험범위 변경')
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptions.testRange]);

  // 다이얼로그 열기/닫기
  const toggleDialog = () => {
    setDialogVisible(!dialogVisible);
  };

  const handleToggleAllSteps = (e) => {
    if (e.target.checked) {
      setSelectedWordSteps(wordStepCount.map((step) => step.stepId));
    } else {
      setSelectedWordSteps([]);
    }
  };

  // 체크박스 핸들러
  const handleCheckboxChange = (id) => {
    setSelectedWordSteps((prev) => {

      if (printType === 'TEST') {
        // TEST 모드에서는 하나만 선택 가능 (기존 선택 해제 후 새로운 선택 적용)
        return [id];
      } else {
        // 기존 멀티 선택 방식 유지
        const updatedSelection = prev.includes(id)
          ? prev.filter((stepId) => stepId !== id)
          : [...prev, id];
        setIsAllSelected(updatedSelection.length === wordStepCount.length); // 전체 선택 여부 업데이트
        return updatedSelection;
      }
    });
  };

  const handleConfirmDialog = () => {

    // 선택된 항목이 하나도 없으면 경고창 표시 후 종료
    if (selectedWordSteps.length === 0) {
      alert("하나 이상의 항목을 선택하세요.");
      return;
    }

    if (selectedOptions.printType === 'TEST') {
      updateTotals();
      updateInputs();
    }
    setDialogVisible(false); // 다이얼로그 닫기
  };

  // 옵션 변경 핸들러
  const handleOptionChange = (event) => {
    const { name, value } = event.target;
    setSelectedOptions((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (selectedOptions.printType === 'TEST') {
      if (wordStepCount.length > 0) {
        if ((selectedOptions.testRange === "EXAM") || (selectedOptions.testRange === "STEP")) {

          // console.log('==> 실행')
          updateInputs();
        }
      }
    }
  };

  const handleRadioChange = (event) => {
    const { name, value } = event.target;
    setSelectedOptions((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // 좌우 배치
  const toggleAnswerSheetLanguage = () => {
    setSelectedOptions((prev) => ({
      ...prev,
      answerSheetLanguage: prev.answerSheetLanguage === 'KOREAN' ? 'ENGLISH' : 'KOREAN',
    }));
  };

  const handleInputChangeTestWord = (event) => {
    const { name, value } = event.target;
    let numericValue = value.replace(/\D/g, ""); // 숫자만 허용

    // 현재 입력값 합계 계산
    const currentTotal = getCurrentTotal();
    const remaining = totalCntWord - (currentTotal - Number(selectedOptions[name]));

    // 입력값이 최대 허용 범위를 초과하지 않도록 처리
    if (numericValue > remaining) {
      numericValue = remaining;
    }

    // 새로운 입력값을 반영한 전체 합계 계산
    const tempOptions = {
      ...selectedOptions,
      [name]: numericValue,
    };

    const totalQCnt =
      Number(tempOptions.wordQ1Cnt || 0) +
      Number(tempOptions.wordQ2Cnt || 0) +
      Number(tempOptions.meaningQ1Cnt || 0) +
      Number(tempOptions.meaningQ2Cnt || 0) +
      Number(tempOptions.exampleQ1Cnt || 0) +
      Number(tempOptions.exampleQ2Cnt || 0);

    // 상태 업데이트
    setSelectedOptions((prev) => ({
      ...prev,
      [name]: numericValue,
      qCnt: totalQCnt, // 총합 입력
    }));
  };

  const handleInputChangeTestSentence = (event) => {
    const { name, value } = event.target;
    let numericValue = value.replace(/\D/g, ""); // 숫자만 허용

    // 현재 입력값 합계 계산
    const currentTotal = getCurrentTotal();
    const remaining = totalCntSentence - (currentTotal - Number(selectedOptions[name] || 0));

    // 입력값이 최대 허용 범위를 초과하지 않도록 처리
    if (numericValue > remaining) {
      numericValue = remaining;
    }

    // 새로운 입력값을 반영한 전체 합계 계산
    const tempOptions = {
      ...selectedOptions,
      [name]: numericValue,
    };

    const totalQCnt =
      Number(tempOptions.emptyQCnt || 0) +
      Number(tempOptions.orderQCnt || 0) +
      Number(tempOptions.meaningQCnt || 0) +
      Number(tempOptions.inputQCnt || 0);

    // 상태 업데이트
    setSelectedOptions((prev) => ({
      ...prev,
      [name]: numericValue,
      qCnt: totalQCnt, // 총합 입력
    }));
  };

  // printType === 'TEST' && materialType === 'TEST' 
  // 입력값 변경 핸들러
  const handleInputChangeTestTest = (event) => {
    const { name, value } = event.target;
    let numericValue = value.replace(/\D/g, ""); // 숫자만 허용

    // 입력값을 최대값으로 제한
    if (numericValue > totals[name.replace("QCnt", "")]) {
      numericValue = totals[name.replace("QCnt", "")];
    }

    // 새로운 입력값을 반영한 전체 합계 계산
    const tempOptions = {
      ...selectedOptions,
      [name]: numericValue,
    };

    const totalQCnt =
      Number(tempOptions.textQCnt || 0) +
      Number(tempOptions.grammarQCnt || 0) +
      Number(tempOptions.listenQCnt || 0);

    // 상태 업데이트
    setSelectedOptions((prev) => ({
      ...prev,
      [name]: numericValue,
      qCnt: totalQCnt, // 총합 입력
    }));

  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSelectedOptions((prev) => ({
      ...prev,
      [name]: value.replace(/\D/g, ''), // 숫자만 입력 가능
    }));
  };

  const handleInputNameChange = (event) => {
    const { name, value } = event.target;
    setSelectedOptions((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Option 체크박스 핸들러
  const handleOptionCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setSelectedOptions((prev) => ({
      ...prev,
      [name]: checked, // name 속성을 이용해 동적으로 상태 업데이트
    }));
  };

  // 변경된 studysetName 반영 여부 확인 함수 추가
  const isStudysetNameChanged = () => {
    return selectedOptions.studysetName !== jsonData.jsonData.studysetName;
  };

  const handleSend = () => {
    if (selectedOptions.printType === 'TEST') {
      const pCount = getCurrentTotal();
      if (pCount <= 0) {
        alert("필요한 옵션 (문제 수 항목)을 선택하세요.");
        return;
      }
    }

    let valueToSend = 1;

    // selectedOptions.printType === 'LIST' || 'WORKSHEET' || 'WORD' || 'SENTENCE'
    if (selectedOptions.materialType === 'WORD') {
      valueToSend = selectedOptions.wordStep === 'step1' ? 1 : 2;
    } else if (selectedOptions.materialType === 'SENTENCE') {
      valueToSend = selectedOptions.sentenceStep === 'step1' ? 1 : 2;
    }

    if (selectedOptions.printType === 'TEST') {
      valueToSend = selectedOptions.wordStep === 'step1' ? 1 : 2;
    }

    if (valueToSend !== null) {
      let testPaperOptions = {}; // testPaperOptions 초기화하여 각 CASE에서 추가
      if (selectedOptions.printType === "TEST") {
        switch (`${selectedOptions.materialType}-${selectedOptions.testRange}`) {
          // CASE 1 : WORD - EXAM
          case "WORD-EXAM":
            testPaperOptions = {
              studysetId: jsonData.jsonData.studysetId,
              wordQ1Cnt: parseInt(selectedOptions.wordQ1Cnt) || 0,
              wordQ2Cnt: parseInt(selectedOptions.wordQ2Cnt) || 0,
              meaningQ1Cnt: parseInt(selectedOptions.meaningQ1Cnt) || 0,
              meaningQ2Cnt: parseInt(selectedOptions.meaningQ2Cnt) || 0,
              exampleQ1Cnt: parseInt(selectedOptions.exampleQ1Cnt) || 0,
              exampleQ2Cnt: parseInt(selectedOptions.exampleQ2Cnt) || 0,
              isShuffle: selectedOptions.isShuffle,
              qCnt: parseInt(selectedOptions.qCnt) || 0,
            };
            break;

          // CASE 2 : WORD - STEP
          case "WORD-STEP":
            testPaperOptions = {
              studysetId: jsonData.jsonData.studysetId,
              wordStepId: selectedWordSteps[0], // section은 선택한 stepId 포함
              wordQ1Cnt: parseInt(selectedOptions.wordQ1Cnt) || 0,
              wordQ2Cnt: parseInt(selectedOptions.wordQ2Cnt) || 0,
              meaningQ1Cnt: parseInt(selectedOptions.meaningQ1Cnt) || 0,
              meaningQ2Cnt: parseInt(selectedOptions.meaningQ2Cnt) || 0,
              exampleQ1Cnt: parseInt(selectedOptions.exampleQ1Cnt) || 0,
              exampleQ2Cnt: parseInt(selectedOptions.exampleQ2Cnt) || 0,
              isShuffle: selectedOptions.isShuffle,
              qCnt: parseInt(selectedOptions.qCnt) || 0,
            };
            break;

          // CASE 3 : SENTENCE - EXAM
          case "SENTENCE-EXAM":
            testPaperOptions = {
              studysetId: jsonData.jsonData.studysetId,
              emptyQCnt: parseInt(selectedOptions.emptyQCnt) || 0,
              emptyQBlankCnt: parseInt(selectedOptions.emptyQBlankCnt) || 0,
              orderQCnt: parseInt(selectedOptions.orderQCnt) || 0,
              meaningQCnt: parseInt(selectedOptions.meaningQCnt) || 0,
              inputQCnt: parseInt(selectedOptions.inputQCnt) || 0,
              isShuffle: selectedOptions.isShuffle,
              qCnt: parseInt(selectedOptions.qCnt) || 0,
            };
            break;

          // CASE 4 : SENTENCE - section
          case "SENTENCE-STEP":
            testPaperOptions = {
              studysetId: jsonData.jsonData.studysetId,
              sentenceStepId: selectedWordSteps[0], // 선택한 stepId 포함
              emptyQCnt: parseInt(selectedOptions.emptyQCnt) || 0,
              emptyQBlankCnt: parseInt(selectedOptions.emptyQBlankCnt) || 0,
              orderQCnt: parseInt(selectedOptions.orderQCnt) || 0,
              meaningQCnt: parseInt(selectedOptions.meaningQCnt) || 0,
              inputQCnt: parseInt(selectedOptions.inputQCnt) || 0,
              isShuffle: selectedOptions.isShuffle,
              qCnt: parseInt(selectedOptions.qCnt) || 0,
            };
            break;

          // CASE 5 : TEST - EXAM 
          case "TEST-EXAM":
            testPaperOptions = {
              studysetId: jsonData.jsonData.studysetId,
              textQCnt: parseInt(selectedOptions.textQCnt) || 0,
              grammarQCnt: parseInt(selectedOptions.grammarQCnt) || 0,
              listenQCnt: parseInt(selectedOptions.listenQCnt) || 0,
              isShuffle: selectedOptions.isShuffle,
              qCnt: parseInt(selectedOptions.qCnt) || 0,
            };
            break;

          // CASE 6 : TEST - section
          case "TEST-STEP":
            testPaperOptions = {
              studysetId: jsonData.jsonData.studysetId,
              testStepId: selectedWordSteps[0], // 선택한 stepId 포함
              textQCnt: parseInt(selectedOptions.textQCnt) || 0,
              grammarQCnt: parseInt(selectedOptions.grammarQCnt) || 0,
              listenQCnt: parseInt(selectedOptions.listenQCnt) || 0,
              isShuffle: selectedOptions.isShuffle,
              qCnt: parseInt(selectedOptions.qCnt) || 0,
            };
            break;

          default:
            console.warn("⚠ 예상치 못한 testPaperOptions 조합:", selectedOptions);
            break;
        }
      }

      // 최종 bodyData 생성
      const bodyData = {
        // userId: jsonData.jsonData.UID,
        isAllStep: isAllSelected,     // 전체, 구간
        stepIds: selectedWordSteps,   // 선택된 차시의 (id ?) 값들 목록

        payload: {
          ...jsonData.jsonData, // 기존 JSON 데이터 유지

          // LIST, WORKSHEET일 경우 reportType 설정
          ...(selectedOptions.printType === "LIST" || selectedOptions.printType === "WORKSHEET"
            ? { reportType: selectedOptions.printType }
            : {}),

          // TEST일 경우 testType 추가  
          ...(selectedOptions.printType === "TEST"
            ? { testType: selectedOptions.testRange }
            : {}),

          // studysetName 변경 여부 확인 후 반영   // 제목
          ...((selectedOptions.printType === "LIST" || selectedOptions.printType === "WORKSHEET" || selectedOptions.printType === "TEST")
            && isStudysetNameChanged()
            ? { studysetName: selectedOptions.studysetName }
            : {}),

          studentName: (selectedOptions.isStudentName ? selectedOptions.studentName : ''),     // 학생이름  
        },
        printOption: {
          layoutType: valueToSend,      // 단 구분
          isSolution: selectedOptions.isSolution, //  true,

          isDivBreak: selectedOptions.isDivBreak, //  true, // header, 모든 페이지에 표시 (로고와 제목)
          isHeader: selectedOptions.isHeader, //  true, // header, 모든 페이지에 표시 (로고와 제목)
          isKorean: (selectedOptions.answerSheetLanguage === 'KOREAN' ? false : true), // /selectedOptions.isKorean, // true, // 'Eng' // 답지구분
          shuffle: selectedOptions.shuffle1, //  'original',    // original, ramdom, abc, 문장(abc 없음 )
          isQuestionNumber: selectedOptions.isQuestionNumber, //  true, // 번호표시, true / false, 
          isPrintDate: selectedOptions.isPrintDate, //  true,    // 출력시간,

          // 자가채점
          isAnswerRange: (selectedOptions.printRange === 'FULL' ? true : false), //  false, // 인쇄범위 : 전체, 오답

          // 해설 추가
          isExplanation: (((selectedOptions.printType === 'TEST' || selectedOptions.printType === 'SELFSCORING') && selectedOptions.materialType === 'TEST') ? selectedOptions.isExplanation : false), //  true, // 해설추가 : 추가, 제외

          styleSheets: {
            fontSize: (
              selectedOptions.printType === 'TEST' && selectedOptions.materialType === 'TEST'
                ? appliedFontSize + 2
                : appliedFontSize
            ),
            lineHeight: appliedLineHeight    // lineHeightMapping
          },
          isFirstWord: selectedOptions.isFirstWord, //true,	// 빈칸채우기 - 빈칸첫단어제외 : 체크 (true / false)
        },
        ...(selectedOptions.printType === "TEST" && { testPaperOptions }),  // TEST인 경우만 testPaperOptions 포함
      };

      handleGeneratePDF(bodyData);
    } else {
      alert("필요한 옵션을 선택하세요.");
    }
  };

  // 현재 printType 값
  const { printType } = selectedOptions;

  return (
    <div className={`${style.side} ${style.scrollable}`}>

      {/* 리스트 - 단어 - 단 */}
      {(selectedOptions.printType === 'LIST' || selectedOptions.printType === 'WORKSHEET' || selectedOptions.printType === 'SELFSCORING') &&
        (
          <>
            {/* <div className={style.selectContainer} style={{ marginTop: "4px", marginBottom: "8px" }}> */}
            <br />
            <div className={style.selectContainer}>
              <div className={style.selectRow}>
                <label htmlFor="printType" className={style.selectLabel}>인쇄 종류</label>
                <select
                  id="printType"
                  name="printType"
                  className={style.select}
                  value={printType}
                  onChange={handleOptionChange}
                  disabled={printType === 'SELFSCORING' || printType === 'TEST' || printType === 'REPORT'}
                >
                  {jsonData.jsonData.reportType === 'WORKBOOK' && (
                    <>
                      <option value="LIST">교재</option>
                      <option value="WORKSHEET">워크시트</option>
                    </>
                  )}
                  {(jsonData.jsonData.reportType === 'SELFSCORING' ||
                    // jsonData.jsonData.reportType === 'TEST' ||
                    jsonData.jsonData.reportType === 'REPORT') && (
                      <option value={printType}>{printType}</option>
                    )}
                  {jsonData.jsonData.reportType === 'TEST' && (
                    <option value="TEST">시험지</option>
                  )}
                </select>
              </div>

              <div className={style.selectRow}>
                <label htmlFor="materialType" className={style.selectLabel}>교재 종류</label>
                <select
                  id="materialType"
                  name="materialType"
                  className={style.select}
                  value={selectedOptions.materialType}
                  onChange={handleOptionChange}
                  disabled={true}
                >
                  <option value="WORD">단어</option>
                  <option value="SENTENCE">문장</option>
                  <option value="TEST">문제집</option>
                </select>
              </div>

              {
                selectedOptions.printType !== 'SELFSCORING' && (
                  <div className={style.selectRow}>
                    <label className={style.selectLabel}>좌우 배치</label>
                    <button
                      type="button"
                      className={style.toggleArrowButton}
                      onClick={toggleAnswerSheetLanguage}
                    >
                      <svg width="100" height="25" viewBox="0 0 84 25" fill="none">
                        {/* 위쪽 화살표 */}
                        <path d="M2 6H82M82 6L74 0M82 6L74 12"
                          stroke="#333"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round" />

                        {/* 아래쪽 화살표 */}
                        <path d="M82 17H2M2 17L10 11M2 17L10 23"
                          stroke="#333"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round" />
                      </svg>
                    </button>
                  </div>
                )
              }

              {selectedOptions.printType === 'SELFSCORING' && (
                <div className={style.selectRow}>
                  <label htmlFor="testType" className={style.selectLabel}>범위 구분</label>
                  <select
                    id="testType"
                    name="testType"
                    className={style.select}
                    value={selectedOptions.testType}
                    onChange={handleOptionChange}
                    disabled={true}
                  >
                    <option value="EXAM">전체</option>
                    <option value="STEP">구간</option>
                  </select>
                </div>
              )}

              {selectedOptions.printType === 'SELFSCORING' && (
                <div className={style.selectRow}>
                  <label htmlFor="printRange" className={style.selectLabel}>인쇄 범위</label>
                  <select
                    id="printRange" // 
                    name="printRange"
                    className={style.select}
                    value={selectedOptions.printRange}
                    onChange={handleOptionChange}
                  >
                    <option value="FULL">전체</option>
                    <option value="PARTOFERROR">오답만</option>
                  </select>
                </div>
              )}
            </div>
          </>
        )}

      {/* 새로 추가된 표시 부분 */}
      {(selectedOptions.printType === 'TEST') &&
        (
          <>
            {/* <div className={style.selectContainer} style={{ marginTop: "4px", marginBottom: "8px" }}> */}
            <br />
            <div className={style.selectContainer}>
              <div className={style.selectRow}>
                <label htmlFor="printType" className={style.selectLabel}>인쇄 종류</label>
                <select
                  id="printType"
                  name="printType"
                  className={style.select}
                  value={printType}
                  onChange={handleOptionChange}
                  disabled={printType === 'SELFSCORING' || printType === 'TEST' || printType === 'REPORT'}
                >
                  {jsonData.jsonData.reportType === 'WORKBOOK' && (
                    <>
                      <option value="LIST">교재</option>
                      <option value="WORKSHEET">워크시트</option>
                    </>
                  )}
                  {(jsonData.jsonData.reportType === 'SELFSCORING' ||
                    // jsonData.jsonData.reportType === 'TEST' ||
                    jsonData.jsonData.reportType === 'REPORT') && (
                      <option value={printType}>{printType}</option>
                    )}
                  {jsonData.jsonData.reportType === 'TEST' && (
                    <option value="TEST">시험지</option>
                  )}
                </select>
              </div>

              <div className={style.selectRow}>
                <label htmlFor="materialType" className={style.selectLabel}>교재 종류</label>
                <select
                  id="materialType"
                  name="materialType"
                  className={style.select}
                  value={selectedOptions.materialType}
                  onChange={handleOptionChange}
                  disabled={true}
                >
                  <option value="WORD">단어</option>
                  <option value="SENTENCE">문장</option>
                  <option value="TEST">문제집</option>
                </select>
              </div>

              <div className={style.selectRow}>
                <label htmlFor="testRange" className={style.selectLabel}>시험 범위</label>
                <select
                  id="testRange"
                  name="testRange"
                  className={style.select}
                  value={selectedOptions.testRange}
                  onChange={handleOptionChange}
                >
                  <option value="EXAM">시험(전체)</option>
                  <option value="STEP">구간테스트</option>
                </select>
              </div>

              {/* <div className={style.selectContainer} style={{ marginBottom: "16px" }}> */}
              <div className={style.selectRow}>
                <label htmlFor="wordStepSelect" className={style.selectLabel}>차시선택</label>
                <button
                  className={style.buttonOne}
                  onClick={toggleDialog}
                  disabled={selectedOptions.testRange !== 'STEP'} // STEP이 아닐 때 비활성화
                >
                  차시 번호 선택
                </button>
              </div>
              {/* </div> */}

            </div>

            <hr
              className={style.sectionDividerLight}
              style={{ marginTop: "8px", marginBottom: "0px" }}
            />


          </>
        )}

      {/* 셔플 - 단어 - 3 가지 */}
      {printType !== 'SELFSCORING' && printType !== 'TEST' && printType !== 'REPORT' &&
        selectedOptions.materialType === 'WORD' && (
          <div className={style.selectContainer}>
            <div className={style.selectRow}>
              <label htmlFor="shuffle1" className={style.selectLabel}>단어 셔플</label>
              <select
                id="shuffle1"
                name="shuffle1"
                className={style.select}
                value={selectedOptions.shuffle1}
                onChange={handleOptionChange}
              >
                <option value="original">원 순서</option>
                <option value="random">랜덤</option>
                <option value="abc">ABC 순</option>
              </select>
            </div>
          </div>
        )}

      {/* 셔플 - 문장 - 2 가지 */}
      {printType !== 'SELFSCORING' && printType !== 'TEST' && printType !== 'REPORT' &&
        selectedOptions.materialType === 'SENTENCE' && (
          <div className={style.selectContainer}>
            <div className={style.selectRow}>
              <label htmlFor="shuffle1" className={style.selectLabel}>문장 셔플</label>
              <select
                id="shuffle1"
                name="shuffle1"
                className={style.select}
                value={selectedOptions.shuffle1}
                onChange={handleOptionChange}
              >
                <option value="original">원 순서</option>
                <option value="random">랜덤</option>
              </select>
            </div>
          </div>
        )}

      {printType !== 'SELFSCORING' && printType !== 'TEST' && printType !== 'REPORT' && (
        <div className={style.selectContainer}>
          <div className={style.selectRow}>
            <label htmlFor="wordStepSelect" className={style.selectLabel}>차시선택</label>
            <button
              disabled={selectedOptions.materialType === 'WORD' && selectedOptions.shuffle1 === 'abc'}
              className={style.buttonOne}
              onClick={toggleDialog}>
              차시 번호 선택
            </button>
          </div>
        </div>
      )}

      {/* 공유 Dialog */}
      {shareDialogVisible && (
        <div className={style.dialogOverlay}>
          <div className={style.dialog}>
            <h3>공유하기</h3>
            <p style={{ marginBottom: '4px' }}>아래 링크를 복사하여 공유하세요.</p>
            <p style={{ color: 'red', fontWeight: 'bold', marginLeft: '4px', marginTop: '4px' }}>(해당 링크는 1개월간 유효합니다.)</p>
            <div className={style.shareContainer}>
              <input
                type="text"
                value={pdfUrl}
                readOnly
                className={style.shareInput}
              />
              <button className={style.button} onClick={() => navigator.clipboard.writeText(`${pdfUrl}`)}>
                복사
              </button>
            </div>
            <br />
            <button className={style.button} onClick={closeShareDialog}>닫기</button>
          </div>
        </div>
      )}

      {dialogVisible && (
        <div className={style.dialogOverlay}>
          <div className={style.dialog}>
            {/* <h3>차시 번호 선택 (수량 변수 처리 수정) {wordStepCount.length}</h3> */}
            <h3>차시 번호 선택</h3>
            <div className={style.dialogContent}> {/* 스크롤 추가 */}
              <table className={style.dialogTable}>

                <thead>
                  <tr>
                    {(selectedOptions.printType !== 'TEST') ? (
                      <th>
                        <input
                          type="checkbox"
                          checked={
                            wordStepCount.length > 0 &&
                            selectedWordSteps.length === wordStepCount.length
                          }
                          onChange={handleToggleAllSteps}
                        />
                      </th>) : (
                      <th>선택</th>
                    )}
                    <th>차시</th>
                    <th>수량</th>
                  </tr>
                </thead>

                {/* <thead>
                  <tr>
                    <th>선택</th>
                    <th>차시</th>
                    <th>수량</th>
                  </tr>
                </thead> */}

                <tbody>
                  {wordStepCount.map((step, index) => (
                    <tr key={step.stepId}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedWordSteps.includes(step.stepId)}
                          onChange={() => handleCheckboxChange(step.stepId, index)}
                        // disabled={printType === 'TEST' && !selectedWordSteps.includes(step.stepId)}
                        />
                      </td>
                      <td>{step.stepCode}</td>
                      {(selectedOptions.printType === 'TEST') && (
                        selectedOptions.materialType === 'TEST'
                          ? (<td>{step.cntGrammarItem + step.cntListenItem + step.cntTextItem}</td>)
                          : (<td>{step.cntWord ?? step.cntSentence}</td>))}

                      {(selectedOptions.printType !== 'TEST') && (
                        <td>{step.cntWord ?? step.cntSentence}</td>)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button className={style.button} onClick={handleConfirmDialog}>확인</button>
          </div>
        </div>
      )}
      {printType !== 'SELFSCORING' && printType !== 'TEST' && (
        <hr
          className={style.sectionDividerLight}
          style={{ marginTop: "8px", marginBottom: "0px" }}
        />
      )}

      {/* 리스트 - 단어 - 단 */}
      {(((selectedOptions.printType === 'LIST' || selectedOptions.printType === 'WORKSHEET') && selectedOptions.materialType === 'WORD')
        || selectedOptions.printType === 'TEST')
        && (
          <div className={style.selectContainer} style={{ marginTop: "0px" }}>
            <div className={style.selectRow}>
              <label htmlFor="wordStep" className={style.selectLabel2}>단</label>
              <div className={style.optionGroup}>
                <input
                  type="radio"
                  id="wordStep1"
                  name="wordStep"
                  value="step1"
                  className={style.radio}
                  checked={selectedOptions.wordStep === 'step1'}
                  onChange={handleRadioChange}
                />
                <label htmlFor="wordStep1" className={style.optionLabel}>1단</label>

                <input
                  type="radio"
                  id="wordStep2"
                  name="wordStep"
                  value="step2"
                  className={style.radio}
                  checked={selectedOptions.wordStep === 'step2'}
                  onChange={handleRadioChange}
                />
                <label htmlFor="wordStep2" className={style.optionLabel}>2단</label>
              </div>
            </div>
          </div>
        )}

      {/* 리스트 - 문장 - 단 */}
      {(selectedOptions.printType === 'LIST' || selectedOptions.printType === 'WORKSHEET') &&
        selectedOptions.materialType === 'SENTENCE' && (
          <div className={style.selectContainer} style={{ marginTop: "0px" }}>
            <div className={style.selectRow}>
              <label htmlFor="sentenceStep" className={style.selectLabel2}>단</label>
              <div className={style.optionGroup}>
                <input
                  type="radio"
                  id="sentenceStep1"
                  name="sentenceStep"
                  value="step1"
                  className={style.radio}
                  checked={selectedOptions.sentenceStep === 'step1'}
                  onChange={handleRadioChange}
                />
                <label htmlFor="sentenceStep1" className={style.optionLabel}>1단</label>

                <input
                  type="radio"
                  id="sentenceStep2"
                  name="sentenceStep"
                  value="step1-top-bottom"
                  className={style.radio}
                  checked={selectedOptions.sentenceStep === 'step1-top-bottom'}
                  onChange={handleRadioChange}
                />
                <label htmlFor="sentenceStep2" className={style.optionLabel}>1단 상하</label>
              </div>
            </div>
          </div>
        )}

      {/* 폰트크기 */}
      {(selectedOptions.printType === 'LIST' || selectedOptions.printType === 'WORKSHEET'
        || selectedOptions.printType === 'TEST') &&
        (
          // <div className={style.soSideOptions}>
          <div className="">

            {/* 폰트 크기 설정 */}
            <div className={style.soOptionGroup}>
              <span className={style.soOptionLabel}>폰트 크기</span>
              <div className={style.soButtonGroup}>
                {Object.keys(fontSizeMapping).map((size) => (
                  <button
                    key={size}
                    className={`${style.soOptionButton} ${selectedFontSize === size ? style.active : ""}`}
                    onClick={() => setSelectedFontSize(size)}
                  >
                    {size}
                  </button>
                ))}
              </div>
            </div>

            {/* 행간 설정 */}
            <div className={style.soOptionGroup} style={{ marginTop: "12px" }}>
              <span className={style.soOptionLabel}>행간</span>
              <div className={style.soButtonGroup}>
                {Object.keys(lineHeightMapping).map((spacing) => (
                  <button
                    key={spacing}
                    className={`${style.soOptionButton} ${selectedLineHeight === spacing ? style.active : ""}`}
                    onClick={() => setSelectedLineHeight(spacing)}
                  >
                    {spacing}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

      <hr
        className={style.sectionDividerLight}
        style={{ marginTop: "16px", marginBottom: "16px" }}
      />

      <div className={style.selectContainer} style={{ marginTop: "0px" }}>
        <div className={style.selectRow}>
          <div className={style.checkboxRow}>
            <input
              type="checkbox"
              id="isHeader"
              name="isHeader"
              checked={selectedOptions.isHeader}
              onChange={handleOptionCheckboxChange}
            />
            <label htmlFor="isHeader" className={style.selectLabel}>Header 표시</label>
          </div>
        </div>

        {/* 출력 시간 */}
        <div className={style.selectRow}>
          <div className={style.checkboxRow}>
            <input
              type="checkbox"
              id="isPrintDate"
              name="isPrintDate"
              checked={selectedOptions.isPrintDate}
              onChange={handleOptionCheckboxChange}
            />
            <label htmlFor="isPrintDate" className={style.selectLabel}>출력 시간</label>
          </div>
        </div>

        {/* 블럭 유지 */}
        {selectedOptions.printType !== 'SELFSCORING' && (
          <div className={style.selectRow}>
            <div className={style.checkboxRow}>
              <input
                type="checkbox"
                id="isDivBreak"
                name="isDivBreak"
                checked={selectedOptions.isDivBreak}
                onChange={handleOptionCheckboxChange}
              />
              <label htmlFor="isDivBreak" className={style.selectLabel}>블럭 유지</label>
            </div>
          </div>
        )}

      </div>

      {(selectedOptions.printType === 'LIST' || selectedOptions.printType === 'WORKSHEET') && (
        <div className={style.selectContainer}>
          <div className={style.selectRow}>
            <div className={style.checkboxRow}>
              <input
                type="checkbox"
                id="isQuestionNumber"
                name="isQuestionNumber"
                checked={selectedOptions.isQuestionNumber}
                onChange={handleOptionCheckboxChange}
              />
              <label htmlFor="isQuestionNumber" className={style.selectLabel}>번호 표시</label>
            </div>
          </div>

        </div>
      )}

      {printType !== 'SELFSCORING' && printType !== 'TEST' && (
        <hr
          className={style.sectionDividerLight}
          style={{ marginTop: "8px", marginBottom: "16px" }}
        />
      )}

      {(selectedOptions.printType === 'LIST' || selectedOptions.printType === 'WORKSHEET') && (
        <div className={style.selectContainer}>
          {/* 교재명 변경 */}
          <div className={style.selectRow}>
            <label className={style.selectLabel}>교재명 변경</label>
            <input
              type="text"
              id="studysetName"
              name="studysetName"
              className={style.select}
              value={selectedOptions.studysetName}
              onChange={handleInputNameChange}
            />
          </div>

          <div className={style.selectRow}>
            <label className={style.selectLabel}>이름 변경</label>
            <input
              type="text"
              id="studentName"
              name="studentName"
              className={style.select}
              value={selectedOptions.studentName}
              onChange={handleInputNameChange}
            />
          </div>
          <div className={style.selectRow}>
            <div className={style.checkboxRow}>
              <input
                type="checkbox"
                id="isStudentName"
                name="isStudentName"
                checked={selectedOptions.isStudentName}
                onChange={handleOptionCheckboxChange}
              />
              <label htmlFor="isStudentName" className={style.selectLabel}>이름 표시하기</label>
            </div>
          </div>

        </div>
      )}

      {/* 자가채점 - 해설추가 */}
      {(selectedOptions.printType === 'SELFSCORING' && selectedOptions.materialType === 'TEST') && (
        < div className={style.selectContainer}>
          <div className={style.selectRow}>
            <div className={style.checkboxRow}>
              <input
                type="checkbox"
                id="isExplanation"
                name="isExplanation"
                checked={selectedOptions.isExplanation}
                onChange={handleOptionCheckboxChange}
              />
              <label htmlFor="isExplanation" className={style.selectLabel}>해설 추가</label>
            </div>
          </div>
        </div>
      )}

      {/* 시험지 1 - ... */}
      {selectedOptions.printType === 'TEST' && (
        <>
          {/* 정답지 추가/제거 */}
          <div className={style.selectContainer} style={{ marginTop: "0px" }}>
            <div className={style.selectRow}>
              <div className={style.checkboxRow}>
                <input
                  type="checkbox"
                  id="isSolution"
                  name="isSolution"
                  checked={selectedOptions.isSolution}
                  onChange={handleOptionCheckboxChange}
                // onChange={handleSolutionCheckboxChange}
                />
                <label htmlFor="isSolution" className={style.selectLabel}>정답지 추가</label>
              </div>
            </div>
          </div>


          {/* 해설지 추가 */}
          {selectedOptions.materialType === 'TEST' && (
            < div className={style.selectContainer}>
              <div className={style.selectRow}>
                <div className={style.checkboxRow}>
                  <input
                    type="checkbox"
                    id="isExplanation"
                    name="isExplanation"
                    checked={selectedOptions.isExplanation}
                    onChange={handleOptionCheckboxChange}
                    disabled={!selectedOptions.isSolution}  // '정답지 추가' 선택된 경우에만 선택가능
                  />
                  <label htmlFor="isExplanation" className={style.selectLabel}>해설 추가</label>
                </div>
              </div>
            </div>)}

          <hr
            className={style.sectionDividerLight}
            style={{ marginTop: "0px", marginBottom: "12px" }}
          />

          {/* 교재명 변경 */}
          <div className={style.selectContainer}>
            <div className={style.selectRow}>
              <label className={style.selectLabel}>교재명 변경</label>
              <input
                type="text"
                id="studysetName"
                name="studysetName"
                className={style.select}
                value={selectedOptions.studysetName}
                onChange={handleInputNameChange}
              />
            </div>
          </div>


          <hr
            className={style.sectionDividerLight}
            style={{ marginTop: "0px", marginBottom: "12px" }}
          />
        </>
      )}

      {/* **************************** */}


      {/* 시험지 - ... */}
      {selectedOptions.printType === 'TEST' && (
        <>
          {/* 문제 수 설정 UI */}
          <div className={style.selectContainer}>
            {selectedOptions.materialType === 'WORD' && (
              <label className={style.selectLabel}>문제 수 설정 &nbsp; (총 가능 단어 수: {totalCntWord || ''})</label>
            )}

            {selectedOptions.materialType === 'SENTENCE' && (
              <label className={style.selectLabel}>문제 수 설정 &nbsp; (총 가능 문제 수: {totalCntSentence || ''})</label>
            )}

            {selectedOptions.materialType === 'TEST' && (
              <label className={style.selectLabel}>문제 수 설정 </label>
            )}

            {/* WORD 관련 문제 설정 (table) */}
            {selectedOptions.materialType === 'WORD' && (
              <table className={style.wordTable}
                style={{ marginTop: "4px", marginBottom: "4px" }}
              // style={{ marginBottom: "0px" }}
              >
                <thead>
                  <tr>
                    <th></th>
                    <th>객관식</th>
                    <th>주관식</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>단어제시</td>
                    <td>
                      <input
                        type="text"
                        id="wordQ1Cnt"
                        name="wordQ1Cnt"
                        value={selectedOptions.wordQ1Cnt || 0}
                        onChange={handleInputChangeTestWord}
                        max={totalCntWord}
                        disabled={totalCntWord === 0}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        id="wordQ2Cnt"
                        name="wordQ2Cnt"
                        value={selectedOptions.wordQ2Cnt || 0}
                        onChange={handleInputChangeTestWord}
                        max={totalCntWord}
                        disabled={totalCntWord === 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>의미제시</td>
                    <td>
                      <input
                        type="text"
                        id="meaningQ1Cnt"
                        name="meaningQ1Cnt"
                        value={selectedOptions.meaningQ1Cnt || 0}
                        onChange={handleInputChangeTestWord}
                        max={totalCntWord}
                        disabled={totalCntWord === 0}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        id="meaningQ2Cnt"
                        name="meaningQ2Cnt"
                        value={selectedOptions.meaningQ2Cnt || 0}
                        onChange={handleInputChangeTestWord}
                        max={totalCntWord}
                        disabled={totalCntWord === 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>예문제시</td>
                    <td>
                      <input
                        type="text"
                        id="exampleQ1Cnt"
                        name="exampleQ1Cnt"
                        value={selectedOptions.exampleQ1Cnt || 0}
                        onChange={handleInputChangeTestWord}
                        max={totalCntWord}
                        disabled={totalCntWord === 0}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        id="exampleQ2Cnt"
                        name="exampleQ2Cnt"
                        value={selectedOptions.exampleQ2Cnt || 0}
                        onChange={handleInputChangeTestWord}
                        max={totalCntWord}
                        disabled={totalCntWord === 0}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            )}

            {/* SENTENCE 관련 문제 설정 */}
            {selectedOptions.materialType === 'SENTENCE' && (
              <>
                <div className={style.inputGroupNoBottom} style={{ gap: "10px" }}>
                  <label htmlFor="emptyQCnt">빈칸채우기 문항수</label>
                  <input
                    type="text"
                    id="emptyQCnt"
                    name="emptyQCnt"
                    value={selectedOptions.emptyQCnt || 0}
                    onChange={handleInputChangeTestSentence}
                  />
                </div>

                <div className={style.inputGroupNoBottom} style={{ marginBottom: "8px", marginLeft: "30px" }}>
                  <label htmlFor="emptyQBlankCnt">빈칸 수</label>
                  <input
                    type="text"
                    id="emptyQBlankCnt"
                    name="emptyQBlankCnt"
                    value={selectedOptions.emptyQBlankCnt || 0}
                    onChange={handleInputChange} />
                </div>

                {/* shuffle 설정 */}
                {/* <div className={style.selectRow} style={{ marginTop: "0px", marginBottom: "4px", marginLeft: "24px" }}>
                  <div className={style.checkboxRow}>

                    <input
                      type="checkbox"
                      id="isFirstWord"
                      name="isFirstWord"
                      checked={selectedOptions.isFirstWord}
                      onChange={handleOptionCheckboxChange}
                    />빈칸 첫단어 제외
                  </div>
                </div> */}

                <div className={style.inputGroupNoBottom}>
                  <label htmlFor="orderQCnt">어순배열 문항수</label>
                  <input
                    type="text"
                    id="orderQCnt"
                    name="orderQCnt"
                    value={selectedOptions.orderQCnt || 0}
                    onChange={handleInputChangeTestSentence}
                  />
                </div>

                <div className={style.inputGroupNoBottom}>
                  <label htmlFor="meaningQCnt">해석 문항수</label>
                  <input
                    type="text"
                    id="meaningQCnt"
                    name="meaningQCnt"
                    value={selectedOptions.meaningQCnt || 0}
                    onChange={handleInputChangeTestSentence}
                  />
                </div>

                <div className={style.inputGroupNoBottom} style={{ marginBottom: "12px" }}>
                  <label htmlFor="inputQCnt">영작 문항수</label>
                  <input
                    type="text"
                    id="inputQCnt"
                    name="inputQCnt"
                    value={selectedOptions.inputQCnt || 0}
                    onChange={handleInputChangeTestSentence}
                  />
                </div>
              </>
            )}

            {/* TEST 관련 문제 설정 */}
            {selectedOptions.materialType === 'TEST' && (
              <>
                <div className={style.inputGroupNoBottomSentence}>
                  <label htmlFor="textQCnt">텍스트 문항수</label>
                  <input
                    type="text"
                    id="textQCnt"
                    name="textQCnt"
                    value={selectedOptions.textQCnt || 0}
                    onChange={handleInputChangeTestTest}
                    max={totals.text}
                    disabled={totals.text === 0} // max 값이 0이면 비활성화
                  />
                  <span style={{ marginLeft: "0px", fontSize: "14px" }}> (최대: {totals.text})</span>
                </div>

                <div className={style.inputGroupNoBottomSentence} style={{ gap: "12px" }}>
                  <label htmlFor="grammarQCnt">구문정독 문항수</label>
                  <input
                    type="text"
                    id="grammarQCnt"
                    name="grammarQCnt"
                    value={selectedOptions.grammarQCnt || 0}
                    onChange={handleInputChangeTestTest}
                    max={totals.grammar}
                    disabled={totals.grammar === 0} // max 값이 0이면 비활성화
                  />
                  <span style={{ marginLeft: "0px", fontSize: "14px" }}> (최대: {totals.grammar})</span>
                </div>

                <div className={style.inputGroupNoBottomSentence} style={{ marginBottom: "12px" }}>
                  <label htmlFor="listenQCnt">듣기평가 문항수</label>
                  <input
                    type="text"
                    id="listenQCnt"
                    name="listenQCnt"
                    value={selectedOptions.listenQCnt || 0}
                    onChange={handleInputChangeTestTest}
                    max={totals.listen}
                    disabled={totals.listen === 0} // max 값이 0이면 비활성화
                  />
                  <span style={{ marginLeft: "0px", fontSize: "14px" }}> (최대: {totals.listen})</span>
                </div>
              </>
            )}

            {/* 공통 문제 수 설정 */}
            <div className={style.inputGroup} style={{ marginTop: "0px", marginBottom: "0px" }}>
              <label htmlFor="qCnt">선택한 총 문제 수 </label>
              <input
                type="text"
                id="qCnt"
                name="qCnt"
                value={selectedOptions.qCnt || 0} onChange={handleInputChange}
                disabled={true}
              />
              {/* <span style={{ marginLeft: "0px", fontSize: "14px", color: "#555" }}> */}
              <span style={{ marginLeft: "0px", fontSize: "14px" }}>
                문제
              </span>
            </div>
          </div>

          <hr
            className={style.sectionDividerLight}
            style={{ marginTop: "0px", marginBottom: "12px" }}
          />
          {/* shuffle 설정 */}
          <div className={style.selectContainer}>
            <div className={style.selectRow}>
              <div className={style.checkboxRow}>
                <input
                  type="checkbox"
                  id="isShuffle"
                  name="isShuffle"
                  checked={selectedOptions.isShuffle}
                  onChange={handleOptionCheckboxChange}
                />
                <label htmlFor="isShuffle" className={style.selectLabel}>문제 순서 shuffle 적용</label>
              </div>
            </div>
          </div>

        </>
      )}

      <hr
        className={style.sectionDividerLight}
        style={{ marginTop: "4px", marginBottom: "24px" }}
      />

      <div className={style.selectContainer}>
        <div className={style.centeredButtonWrapper}>
          <button
            className={`${style.centeredButton} ${style.buttonTwo}`}
            onClick={handleSend}
          >
            만들기
          </button>
        </div>
      </div>

      {selectedOptions.printType === 'TEST' && (
        <div className={style.selectContainer}>
          <div className={style.centeredButtonWrapper}>
            <button
              className={`${style.centeredButton} ${style.buttonThree}`}
              onClick={openShareDialog}
              disabled={isReportCardView}
            >공유 </button>
          </div>
        </div>

      )}

    </div>
  );
}

export default Side;
